import { NotFoundPage } from 'Pages';

export const NotFoundScreen = () => {
  return <NotFoundPage />;
};
